import React, { Component } from "react";
import injectSheet from "react-jss";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { flexUtils, palette } from "../../../Theme/Theme";
import ScrollableAnchor from "react-scrollable-anchor";
import { configureAnchors } from "react-scrollable-anchor";
import styled from "styled-components";
import { keyframes } from "styled-components";
import play from "../../../../assets/play.png";
import Thumbnails from "../Shows/Thumbnails";
import { Droppable } from "react-beautiful-dnd";
import PlayListItem from "./PlayListItem";
import * as TempActions from "../../../Actions/TempPlaylistActions.js";
import * as Actions from "../../../Actions/Actions.js";
import { Prompt } from "react-router";
import { Link } from 'react-router-dom'
import { isMobile } from "react-device-detect";

configureAnchors({ offset: -60, scrollDuration: 700 });

const FadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Container = styled.div`
  overflow: hidden;
  position: absolute;
  transition-delay: 0.4s;
  transition: all 0.7s;
  top: 7vh;
  left: 0;
  display: flex;
  width: 100vw;
  height: 88.5vh;
`;

const Title = styled.div`
  color: ${palette.white};
  font-size: 2vw;
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding: 0.5rem;
`;

const FlexRow = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
  position: fixed;
  left: 2vw;
  top: 0.5vh;
  z-index: 5;
`;

const Exit = styled.div`
  transition: all 0.7s;
  width: 2vw;
  font-size: 2vw;
  color: white;
  &:hover {
    cursor: pointer;
    color: ${palette.red};
  }
`;

const ImageContainer = styled.div`
  width: 100vw;
  height: 88.5vh;
  zindex: 10;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  overflow-y: scroll;
`;

const Icon = styled.div`
  transition: all 0.4s;
  width: 2vw;
  font-size: 2rem;
  color: ${palette.white};
  opacity: 0.3;
  &:hover {
    opacity: 1;
    cursor: pointer;
    color: ${palette.white};
  }
`;
const Trash = Icon.extend`
  position: absolute;
  top: 4%;
  left: 2%;
  &:hover {
    color: ${palette.red};
  }
`;

const Play = Icon.extend`
  position: absolute;
  font-size: 1.8rem;
  top: 5%;
  left: 14%;
  &:hover {
    color: ${palette.green};
  }
`;

const ImageControls = styled.div`
  width: 18vw;
  height: 10.17;
  margin-left: -18vw;
  position: relative;
`;

const CancelConfirmContianer = styled.div.attrs({})`
  animation: ${FadeIn} 0.7s linear;
  position: absolute;
  top: ${props => props.isMobile ? '0' : '2vw'};
  left: ${props => props.isMobile ? '5px' : '5vw'};
  background-color: black;
  color: ${palette.white};
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: ${props => props.isMobile ? '4rem' : '8vw'};
  flex-direction: column;
  width: ${props => props.isMobile ? '8rem' : '16vw'};
  border-radius: 5px;
  border: 1px solid ${palette.white};
  padding: 1vw;
`;
const ButtonContainer = styled.div`
  width: ${props => props.isMobile ? '7rem' : '15vw'};
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const Confirm = styled.div.attrs({
  children: "Confirm"
})`
  animation: ${FadeIn} 0.7s linear;
  transition: all 0.7s;
  width: ${props => props.isMobile ? '3rem' : '7vw'};
  height: ${props => props.isMobile ? '1rem' : '2vw'};
  color: ${palette.white};
  display: flex;
  flex-direction: row;
  align-text: center;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: ${props => props.isMobile ? '.4rem' : '1.3vw'};
  border-radius: 10px;
  border: 1px solid ${palette.white};
  &:hover {
    cursor: pointer;
    background-color: ${palette.green};
    border: 1px solid ${palette.green};
  }
`;

const Cancel = styled(Confirm).attrs({
  children: "Cancel"
})`
  &:hover {
    cursor: pointer;
    background-color: ${palette.red};
    border: 1px solid ${palette.red};
  }
`;

const KeepChanges = styled.div.attrs({
  children: "Keep these changes?"
})`
  color: ${palette.white};
  font-size: ${props => props.isMobile ? '.3rem' : '1.2vw'};
  margin-bottom: 0.5vw;
`;

const PlaceHolder = styled.div`
  height: 8vw;
  width: 16vw;
`;

const LinkContainer = styled.div`
  width: 25vw;
  text-align: center;
  margin: 3vw;
  font-size: 1.8rem;
`

const AddShowToPlaylist = styled(Link).attrs({
  children: '+ Add shows to playlist',
  to: '/Home'
})`
  transition: all .4s;
  color: ${palette.white};
  text-decoration: none;
  font-size: ${props => props.ismobile ? '.5rem' : '1rem'}
  &:hover {
    color: ${palette.teal}
  }
`

class ShowView extends Component {
  constructor() {
    super();
    this.state = {
      cancel: false
    }
    this.saveChanges = this.saveChanges.bind(this);
  }
  render() {
    return (
      <Container style={{ opacity: this.props.opacity }}>
        <Prompt
          when={this.shouldPrompt()}
          message="You have unsaved changes. Are you sure you want to leave?"
        />
        <FlexRow>
          <Exit onClick={()=>{this.exit(false)}} className={`fas fa-arrow-left`} />
          <Title>{this.props.match.params.title}</Title>
        </FlexRow>
        {!this.props.isFirstTime ? (
          <CancelConfirmContianer isMobile={isMobile}>
            <KeepChanges isMobile={isMobile}/>
            <ButtonContainer isMobile={isMobile}>
              <Cancel isMobile={isMobile} onClick={()=>{this.resetPlaylist()}} />
              <Confirm isMobile={isMobile} onClick={this.saveChanges} />
            </ButtonContainer>
          </CancelConfirmContianer>
        ) : null}
        {this.props.playList.state.loaded ? (
            <Droppable droppableId={`${this.props.id}`}>
              {provided => (
                <ImageContainer
                  innerRef={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {this.props.playList.contents.video_user_categories.map(
                    (content, index) => {
                      return (
                        <PlayListItem
                          content={content}
                          index={index}
                          key={index}
                          alt=""                          
                        />
                      );
                    }
                  )}
                  {provided.placeholder}
                  <LinkContainer>
                    <AddShowToPlaylist ismobile={isMobile ? 1 : 0}/>
                  </LinkContainer>
                </ImageContainer>
              )}              
            </Droppable>
        ) : (
          this.returnLoading()
        )}
      </Container>
    );
  }

  resetPlaylist = () => {
    this.props.dispatch(TempActions.resetPlaylist())
  }

  shouldPrompt = () => {
    // console.log(this.state.cancel)
    // console.log(this.props.isFirstTime)
    if(this.state.cancel) return false
    if (!this.props.isFirstTime) return true
    return false
  }

  exit = (shouldCancel) => {
    // console.log(this.props.history)
    if (shouldCancel) {
      this.setState({cancel: true})
    }
    this.props.history.goBack();
    return;
  };

  componentWillUnmount = () => {
  }

  saveChanges() {
    this.props.dispatch(
      TempActions.saveChanges(this.props.id, this.props.user.token)
    );
    if (this.props.match.params.title !== undefined) {
      setTimeout(() => {
        // this.props.history.push("/Home");
      }, 100);
      return;
    }
    this.props.showDiv();
  }
  returnLoading() {
    <div>Loading</div>;
  }
  componentDidMount() {
    if (this.props.match.params.title !== undefined) {
      while (this.props.playlists[0].title === undefined) {}
      for (let i = 0; i < this.props.playlists.length; i++) {
        if (this.props.playlists[i].title === this.props.match.params.title) {          
          this.props.dispatch(
            Actions.getPlaylistContents(
              this.props.user.token,
              this.props.playlists[i].id
            )
          );
        }
      }
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    playList: state.tempState.playList,
    isFirstTime: state.tempState.isFirstTime,
    playlists: state.mainState.playlists,
    id: state.tempState.playlistId
  };
};

export default withRouter(connect(mapStateToProps)(ShowView));



// WEBPACK FOOTER //
// ./src/js/Components/Home/Playlists/PlayList.jsx